//USER
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';
export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_ALTER_PASSWORD_SUCCESS = 'USER_ALTER_PASSWORD_SUCCESS';
export const USER_ALTER_PASSWORD_ERROR = 'USER_ALTER_PASSWORD_ERROR';
export const USER_REGISTER_ERROR = 'USER_REGISTER_ERROR';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_ERROR = 'USER_UPDATE_ERROR';
export const USER_UPDATE_CALENDAR_TOKEN = 'USER_UPDATE_CALENDAR_TOKEN';

//ARTICLE
export const ADD_ARTICLE_SUCCESS = 'ADD_ARTICLE_SUCCESS';
export const ADD_ARTICLE_ERROR = 'ADD_ARTICLE_ERROR';
export const ADD_ARTICLE_IMAGE_SUCCESS = 'ADD_ARTICLE_SUCCESS';
export const ADD_ARTICLE_IMAGE_ERROR = 'ADD_ARTICLE_ERROR';
export const ADD_ARTICLE_COMMENT_SUCCESS = 'ADD_ARTICLE_COMMENT_SUCCESS';
export const ADD_ARTICLE_COMMENT_ERROR = 'ADD_ARTICLE_COMMENT_ERROR';
export const FETCH_ARTICLE_COMMENTS_SUCCESS = 'FETCH_ARTICLE_COMMENTS_SUCCESS';
export const FETCH_ARTICLE_COMMENTS_ERROR = 'FETCH_ARTICLE_COMMENTS_ERROR';
export const UPDATE_ARTICLE_SUCCESS = 'UPDATE_ARTICLE_SUCCESS';
export const UPDATE_ARTICLE_EVENT_SUCCESS = 'UPDATE_ARTICLE_EVENT_SUCCESS';
export const UPDATE_ARTICLE_SUCCESS_ERROR = 'UPDATE_ARTICLE_SUCCESS_ERROR';
export const UPDATE_ARTICLE_COMMENTS_SUCCESS =
  'UPDATE_ARTICLE_COMMENTS_SUCCESS';
export const UPDATE_ARTICLE_COMMENTS_ERROR = 'UPDATE_ARTICLE_COMMENTS_ERROR';
export const RESET_ARTICLE_COMMENTS = 'RESET_ARTICLE_COMMENTS';
export const FETCH_ARTICLES_SUCCESS = 'FETCH_ARTICLES_SUCCESS';
export const FETCH_ARTICLE_SUCCESS = 'FETCH_ARTICLE_SUCCESS';
export const FETCH_ARTICLE_ERROR = 'FETCH_ARTICLE_ERROR';
export const RESET_ARTICLES = 'RESET_ARTICLES';
export const REMOVE_ARTICLE_COMMENT_SUCCESS = 'REMOVE_ARTICLE_COMMENT_SUCCESS';
export const REMOVE_ARTICLE_COMMENT_ERROR = 'REMOVE_ARTICLE_COMMENT_ERROR';
export const SET_ARTICLE_EVENTS = 'SET_ARTICLE_EVENTS';

//CATEGORIES
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_ERROR = 'FETCH_CATEGORIES_ERROR';

//CLIPPINGS
export const FETCH_CLIPPINGS_SUCCESS = 'FETCH_CLIPPINGS_SUCCESS';

//ROLES
export const ADMIN_ROLE = 'ADMIN';

//TEMPLATES
export const ADD_TEMPLATE_ERROR = 'ADD_TEMPLATE_ERROR';
export const ADD_TEMPLATE_SUCCESS = 'ADD_TEMPLATE_SUCCESS';
export const FETCH_TEMPLATES_SUCCESS = 'FETCH_TEMPLATES_SUCCESS';
export const FETCH_TEMPLATE_ERROR = 'FETCH_TEMPLATE_ERROR';
export const FETCH_TEMPLATE_SUCCESS = 'FETCH_TEMPLATES_SUCCESS';
export const UPDATE_TEMPLATE_SUCCESS = 'UPDATE_TEMPLATE_SUCCESS';
export const UPDATE_TEMPLATE_ERROR = 'UPDATE_TEMPLATE_ERROR';

//RECORDS
export const ADD_RECORD_ERROR = 'ADD_RECORD_ERROR';
export const ADD_RECORD_SUCCESS = 'ADD_RECORD_SUCCESS';
export const FETCH_RECORD_SUCCESS = 'FETCH_RECORD_SUCCESS';
export const FETCH_RECORD_ERROR = 'FETCH_RECORD_ERROR';
export const UPDATE_RECORD_SUCCESS = 'UPDATE_RECORD_SUCCESS';
export const UPDATE_RECORD_ERROR = 'UPDATE_RECORD_ERROR';
export const DOWNLOAD_FILE_ERROR = 'DOWNLOAD_FILE_ERROR';
